"use strict";

var _qrSvg = require("./components/qr-svg");

module.exports = { QRCode: _qrSvg.QRCode };